import { useSelector } from 'react-redux';
import { ReportVersion } from '../../app/LocalReportVersionsModal/LocalReportVersionsModal.prototypes';
import { selectReportVersions } from '../../selectors';

export const useReportVersions = (): ReportVersion[] | null => {
  const reportVersions = useSelector(selectReportVersions);

  return reportVersions;
};
